/**
 * @copyright Copyright 2016 The MathWorks, Inc.
 */
define([], function () {
    return (e) => {
        /**
         * Prevents further propagation of the current event in the bubbling phase.
         * Prevents the default action of the event from happening.
         */
        e.stopPropagation();
        e.preventDefault();
        return false;
    };
});